// extracted by mini-css-extract-plugin
module.exports = {"buttonsFooter":"ScanPackedBoxes_buttonsFooter__TBTta"};